import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent } from '@mzic/mzic-components';

const EMPHASIS_MARK = '⁣';

/**
 * The provider account must first enroll two-factor on the provider's own
 * site (connection error PROVIDER_2FA_SETUP_REQUIRED); nothing to enter here.
 */
@Component({
  selector: 'lib-provider-setup-required-step',
  standalone: true,
  imports: [CommonModule, TranslocoModule, MzicSvgComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './provider-setup-required-step.component.html',
  styleUrl: './provider-setup-required-step.component.scss',
})
export class ProviderSetupRequiredStepComponent {
  @Input() providerName = '';

  @Output() retry = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  readonly stepKeys = [
    'lang.provider_setup_required_step_sign_in',
    'lang.provider_setup_required_step_configure',
    'lang.provider_setup_required_step_return',
  ];

  get emphasisParams(): { provider: string } {
    return { provider: EMPHASIS_MARK };
  }

  /** Splits the translated copy around the emphasized provider name. */
  descriptionParts(text: string): [string, string, string] {
    const [lead, ...rest] = text.split(EMPHASIS_MARK);
    return rest.length === 0
      ? [text, '', '']
      : [lead, this.providerName, rest.join('')];
  }
}
